import _ from 'lodash';
import { ViewerImage } from 'app/components/Viewer/types';
import {
  computeScaleFactorFromStoredViewport,
  getMatchingResolutionViewport,
  getViewportDimensions,
  injectImageDimensionsInViewport,
  rescaleAnnotationsPoints,
} from 'app/utils/cornerstone/imageUtils';

export default function adaptStoredViewportAndAnnotationsToLoadedImage(
  image: Pick<ViewerImage, 'displayableImage' | 'viewport' | 'annotations'>
) {
  const { displayableImage, viewport, annotations } = image;
  if (!viewport || !displayableImage) return { viewport, annotations };

  let adaptedViewport = viewport;
  let adaptedAnnotations = annotations;
  if (
    !_.isEqual(
      _.pick(displayableImage, ['width', 'height']),
      _.pick(getViewportDimensions(viewport), ['width', 'height'])
    )
  ) {
    const scaleFactor = computeScaleFactorFromStoredViewport(
      viewport,
      displayableImage
    ).scaleFactor;
    if (annotations) {
      adaptedAnnotations = rescaleAnnotationsPoints(annotations, scaleFactor);
    }
    adaptedViewport = injectImageDimensionsInViewport(viewport, displayableImage);
  }

  adaptedViewport = getMatchingResolutionViewport(adaptedViewport, displayableImage);

  return { viewport: adaptedViewport, annotations: adaptedAnnotations };
}
